import _Skeleton from './Skeleton';

import './style/index.js';

export type { SkeletonProps } from './Skeleton';
export * from './type';

export const Skeleton = _Skeleton;
export default Skeleton;
